import { render, staticRenderFns } from "./AntiCarton.vue?vue&type=template&id=86451e5c&scoped=true&"
import script from "./AntiCarton.vue?vue&type=script&lang=js&"
export * from "./AntiCarton.vue?vue&type=script&lang=js&"
import style0 from "./AntiCarton.vue?vue&type=style&index=0&id=86451e5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86451e5c",
  null
  
)

export default component.exports